import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";
import Select from "react-select";


export default class SubCategory extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Categories_Subs._name);
		this.state._categories = [];
		this.state.parent = this.props.parent;
	}

	componentDidMount() {
		super.componentDidMount();
		this.getCategories();
	}

	getCategories = async () => {
		let model = new API.BuildClass(Types.Categories._name, API.RequestType.READ_ALL);
		this.data = await model.submit(null, API.RequestType.READ_ALL);
		this.setState({
			_categories: this.data.items
		});
	}


	form = () => {
		let {properties} = this.model;
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>
						<div className={'col-12'}>
							<div className={'form-group'} style={{zIndex: 999}}>
								<Select
									key={this.state._categories}
									placeholder={"Category Select"}
									isMulti={false}
									isClearable
									value={this.state._categories.map((category) => {
										if (category.pkey === this.state.category) {
											return {value: category.pkey, label: category.name}
										} else {
											return null
										}
									})}
									onChange={(value) => {
										this.model.parent = value.value;
										this.setState({selectedCategory: value, category: value.value})
									}}
									options={this.state._categories.map(category => {
										return (
											{value: category.pkey, label: category.name})
									})}
									styles={this.styles}
								/>
							</div>
						</div>
						<div className={"col-12"}>
							<div className={'form-group'}>
								<div className="form-group">
									<Framework.Elements.TextField
										property={properties.name}
										value={object.name}
										error={object.name_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						</div>
					</div>
				</fieldset>
				<Framework.Elements.LoadingSpinner isLoading={loading}/></div>

		)
	}
	customStyles = {
		control: (provided) => ({
			...provided,
			minHeight: 32
		}),
		valueContainer: (provided) => ({
			...provided,
			padding: '1px 6px'
		}),
		dropdownIndicator: (provided) => ({
			...provided,
			padding: 4,
		}),
		menu: (provided) => ({
			...provided,
			zIndex: 3,
		})
	};

	styles = {
		...this.customStyles, ...{
			container: (provided) => ({
				...provided,
			}),
			control: (provided) => ({
				...provided,
				minHeight: '30px'
			}),
			valueContainer: (provided) => ({
				...provided,
				overflow: 'visible',
				padding: '1px 8px'
			}),
			placeholder: (provided, state) => ({
				...provided,
				position: "absolute", //(state.hasValue && state.selectProps.value.label) &&
				top: -4,
				left: -4,
				marginLeft: 0,
				marginRight: 0,
				fontSize: '1rem',
				color: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'rgba(0, 0, 0, 0.54)',
				transition: "top 200ms, margin-left 200ms, background-color 200ms, font-size 200ms, transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms",
				transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) ? "translate(14px, -6px) scale(0.75) !important" : "translate(14px, 10px) scale(1) !important",
				transformOrigin: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && "top left",
				//transform: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'matrix(0.75, 0, 0, 0.75, 14, -6)',
				backgroundColor: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && 'white',
				padding: ((state.hasValue && state.selectProps.value.label) || state.selectProps.inputValue) && '0 8px',
			}),
			multiValue: (provided) => ({
				...provided,
				zIndex: 2
			})
		}
	};
}
